import { memo } from "react";

import withT from "neetocommons/react-utils/withT";
import { Download } from "neetoicons";
import { Button, Callout } from "neetoui";
import { Trans } from "react-i18next";

import { DOWNLOAD_SAMPLE_EMAIL_CSV_FILE } from "./constants";

const Requirements = withT(({ t, fileSize }) => (
  <Callout className="flex flex-col items-center py-6" style="info">
    <ul className="flex list-outside list-disc flex-col gap-y-1 font-normal leading-normal">
      {fileSize && (
        <li>
          {t("neetoMolecules.shareViaLink.requirements.fileTypeAndSize", {
            limit: fileSize,
          })}
        </li>
      )}
      <li>
        <Trans
          components={{ strong: <strong className="font-semibold" /> }}
          i18nKey="neetoMolecules.shareViaLink.requirements.shouldContainColumns"
        />
      </li>
    </ul>
    <Button
      href={DOWNLOAD_SAMPLE_EMAIL_CSV_FILE}
      icon={Download}
      iconPosition="left"
      label={t("neetoMolecules.shareViaLink.bulkUploadPane.downloadSampleCSV")}
      style="link"
    />
  </Callout>
));

export default memo(Requirements);
